




































































































































































import { RegraFiscal } from '@/models/fiscal/RegrasFiscais';
import AlertModule from '@/store/vuex/aplicacao/AlertModule';
import { RegrasFiscaisUseCase } from '@/usecases/fiscal/RegrasFiscaisUseCase';
import Vue from 'vue';
import { Component, Ref } from 'vue-property-decorator';
import DialogoDeAdicionarNovasRegrasFiscais from './DialogoDeAdicionarNovasRegrasFiscais.vue';
import AppStore from '@/store/vuex/aplicacao/AppStore';
import Confirmacao from '@/components/ui/Confirmacao.vue';

@Component({ 
	components: {
		DialogoDeAdicionarNovasRegrasFiscais,
		Confirmacao,
	}, 
})
export default class TelaDeRegrasFiscais extends Vue {
	@Ref() dialogoDeAdicionarNovasRegrasFiscais!: DialogoDeAdicionarNovasRegrasFiscais
	@Ref() confirmaExclusao!: Confirmacao
	regrasFiscaisUseCase = new RegrasFiscaisUseCase();

	searchQuery = '';
	currentPage = 1;
	pageSize = 9999;

	levelLabels: Record<number, string> = {
		1: 'Origem + Tipo',
		2: 'Apenas Origem',
		3: 'Apenas Tipo',
		4: 'Padrão',
	};

	labelMap: Record<string, string> = {
		COMPRADO: 'Comprado',
		FABRICADO: 'Fabricado',
	};

	rules: RegraFiscal[] = [];
	buscandoRegrasFiscais = false;
	excluindoId: string | null = null;

	mounted(){
		this.buscarRegrasFiscais();
	}

	formatLabel(value: string | null | undefined): string {
		if (!value) return '-';
		return this.labelMap[value] ?? value;
	}

	computeLevel(
		codigoOrigem: number | null | undefined,
		tipoOrigem: string | null | undefined,
	): number {
		const hasOrigem = codigoOrigem !== null && codigoOrigem !== undefined;
		const hasTipo =
			tipoOrigem !== null &&
			tipoOrigem !== undefined &&
			tipoOrigem !== 'NAO_CONFIGURADAS';

		if (hasOrigem && hasTipo) return 1;
		if (!hasTipo && hasOrigem) return 2;
		if (hasTipo && !hasOrigem) return 3;
		return 4;
	}

	async buscarRegrasFiscais() {
		try {
			this.buscandoRegrasFiscais = true;
			const regras = await this.regrasFiscaisUseCase.findRegrasFiscais();

			this.rules = regras.map((regra: any) => ({
				id: regra.id,
				regimeFiscal: regra.regimeFiscal,
				tributacao: regra.tributacao,
				transacao: regra.transacao,
				entradaSaida: regra.entradaSaida,
				tipoOrigem: regra.tipoOrigem ?? null,
				codigoOrigem: regra.codigoOrigem ?? null,
				level: this.computeLevel(regra.codigoOrigem, regra.tipoOrigem) as 1 | 2 | 3 | 4,
			})).sort((a, b) => a.level - b.level);
		} catch (e) {
			AlertModule.setError('Erro ao buscar regras fiscais: ' + e);
			this.buscandoRegrasFiscais = false
		} finally {
			this.buscandoRegrasFiscais = false;
		}
	}

	get filteredRules(): RegraFiscal[] {
		const q = this.searchQuery.toLowerCase();
		const filtered = q
			? this.rules.filter(r =>
				this.formatLabel(r.regimeFiscal).toLowerCase().includes(q) ||
				r.tributacao.toLowerCase().includes(q) ||
				this.formatLabel(r.transacao).toLowerCase().includes(q) ||
				this.formatLabel(r.entradaSaida).toLowerCase().includes(q) ||
				(r.tipoOrigem ? this.formatLabel(r.tipoOrigem).toLowerCase().includes(q) : false) ||
				(r.codigoOrigem?.toString().includes(q) ?? false),
			)
			: this.rules;

		const start = (this.currentPage - 1) * this.pageSize;
		return filtered.slice(start, start + this.pageSize);
	}

	get totalRules(): number {
		const q = this.searchQuery.toLowerCase();
		return q
			? this.rules.filter(r =>
				this.formatLabel(r.regimeFiscal).toLowerCase().includes(q) ||
				r.tributacao.toLowerCase().includes(q) ||
				this.formatLabel(r.transacao).toLowerCase().includes(q) ||
				this.formatLabel(r.entradaSaida).toLowerCase().includes(q) ||
				(r.tipoOrigem ? this.formatLabel(r.tipoOrigem).toLowerCase().includes(q) : false) ||
				(r.codigoOrigem?.toString().includes(q) ?? false),
			).length
			: this.rules.length;
	}

	async deleteRule(regra: RegraFiscal) {
		try {
			const confirmado = await this.confirmaExclusao.mostrar();
			if (!confirmado) return;

			this.excluindoId = regra.id;
			await this.regrasFiscaisUseCase.deleteRegraFiscal(regra);
			AlertModule.setSuccess('Regra excluída com sucesso!');
			await this.buscarRegrasFiscais();
		} catch (e) {
			AlertModule.setError('Erro ao excluir regras fiscais: ' + e);
		} finally {
			this.excluindoId = null;
		}
	}

	createRule() {
		this.dialogoDeAdicionarNovasRegrasFiscais.mostrar()
	}

	get modoNoturno() {
		return AppStore.modoNoturno
	}
}
